
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('p')]),_c('g',[_c('g',[_c('path',{staticClass:"cls-1",attrs:{"d":"M197.85,530l37.76,44.94L388.7,446.31,764.52,132.19c26.84-22.54,33.58-59.1,11-85.93L755,21.88c-22.54-26.82-59.7-26.51-86.53-4L292.69,332.05,139.6,460.65l37.76,44.94Z"}}),_c('polygon',{staticClass:"cls-1",attrs:{"points":"70.69 554.79 131.03 626.54 202.7 598.85 110.41 489.02 70.69 554.79"}}),_c('polygon',{staticClass:"cls-1",attrs:{"points":"91.43 642.49 48.19 591.1 -0.28 675.75 91.43 642.49"}})]),_c('path',{staticClass:"cls-1",attrs:{"d":"M795.29,798.64H5.28c-2.76,0-5-5.5-5-12.27V741.52c0-6.78,2.24-12.27,5-12.27h790c2.76,0,5,5.49,5,12.27v44.85C800.28,793.14,798.05,798.64,795.29,798.64Z"}})])])
          )
        }
      }
    